/**
 * realtime - the page side of the framework's socket.io push, entry point.
 *
 *   route.php:  'vendors' => ['socketio'], 'libs' => ['realtime']
 *               (or both in the SITE config for every page)
 *
 *   await g.realtime.join('bsp:project:12');       // { ok: true } | { ok: false, reason }
 *   const off = g.realtime.on('project-changed', (payload) => { … });
 *   g.realtime.leave('bsp:project:12');
 *   g.realtime.state();   // { enabled, path, connected, ended, reason, rooms }
 *
 * Connects by itself at load when main.json's realtime block is enabled
 * (g.init hands it over) and a user is signed in; re-joins its rooms after
 * every reconnection; a session ended anywhere ends the lib for this page
 * (`realtime:ended`). Document events: realtime:connected / disconnected /
 * ended / left / event. Full reference: docs/libs/realtime.md.
 */
import { realtime, boot } from './realtime.js';

// Bump on every meaningful change to the library.
const VERSION = '0.1.0';

realtime.version = () => VERSION;

if (window.g) {
	window.g.realtime = realtime;
	window.g.registerLib('realtime');
} else {
	window.realtime = realtime; // genus not loaded (shouldn't happen in the template)
}

boot();
